var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg02(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    xmlnsV: "https://vecta.io/nano",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#B)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.126 0c-3.791 0-6.875 2.87-6.875 6.398a6.1 6.1 0 0 0 1.015 3.347l-.924 2.286a1.25 1.25 0 0 0 1.159 1.719 1.25 1.25 0 0 0 .504-.106l2.789-1.23c.695.221 1.463.329 2.331.329 1.814 0 3.524-.642 4.813-1.809 1.327-1.2 2.059-2.813 2.061-4.545C31.995 2.866 28.911 0 25.126 0zm0 10.243c-.752 0-1.368-.107-1.883-.326a1.25 1.25 0 0 0-.995.006l-.434.191.034-.084a1.25 1.25 0 0 0-.208-1.279c-.582-.682-.889-1.496-.889-2.353 0-2.15 1.962-3.898 4.375-3.898s4.372 1.747 4.375 3.89c-.003 2.125-1.966 3.854-4.375 3.854zm4.922 17.383c.225 1.076-.043 2.182-.736 3.034S27.593 32 26.494 32H3.632c-1.099 0-2.126-.488-2.818-1.34s-.961-1.958-.736-3.034c.707-3.38 2.578-6.456 5.269-8.661 1.44-1.18 3.082-2.08 4.832-2.666A8.07 8.07 0 0 1 7 9.875c0-4.446 3.597-8.062 8.019-8.062a6.91 6.91 0 0 1 .353.009 1.25 1.25 0 1 1-.118 2.497 4.46 4.46 0 0 0-.235-.006c-3.043 0-5.518 2.495-5.518 5.563s2.476 5.563 5.519 5.563c.141 0 .275.024.401.067 4.977.115 9.578 2.623 12.363 6.761a1.25 1.25 0 1 1-2.074 1.396C23.323 20.116 19.343 18 15.063 18c-6.037 0-11.31 4.264-12.538 10.138a1.13 1.13 0 0 0 .229.946c.126.155.408.416.878.416h22.862c.47 0 .752-.261.878-.416.216-.265.299-.61.229-.946a1.25 1.25 0 0 1 2.447-.511z",
    fill: "url(#A)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 0,
    y1: 16.077,
    x2: 32,
    y2: 16.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6366f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8b5cf6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d946ef"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "B"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg02);
export default __webpack_public_path__ + "static/media/02.49fbc12f411dc426f2f4be6b6d62a147.svg";
export { ForwardRef as ReactComponent };